<path
    d="M36.4725 23.6828L15.0619 1.5428C14.3604 0.817834 13.2247 0.819053 12.5244 1.54655C11.8246 2.27395 11.8264 3.45229 12.528 4.17782L32.6642 25.0001L12.5273 45.8223C11.8258 46.5479 11.824 47.7255 12.5236 48.453C12.8747 48.8177 13.3346 49 13.7945 49C14.2533 49 14.7114 48.8189 15.0618 48.4567L36.4725 26.3173C36.8104 25.9687 37 25.4943 37 25.0001C37 24.5058 36.8099 24.032 36.4725 23.6828Z"
    fill="currentColor"
/>
